(function () {
  'use strict';

  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function prefersReducedMotion() {
    return !!reduceMotion.matches;
  }

  var editorTab = {};

  function initGuide(guide) {
    var tabs = Array.from(guide.querySelectorAll('.br-ring-guide__tab'));
    var panels = Array.from(guide.querySelectorAll('.br-ring-guide__panel'));
    if (!tabs.length || !panels.length) return;

    var sectionId = guide.getAttribute('data-section-id');
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    var currentTab = 0;
    var currentStep = 0;
   
    var programmaticScroll = null;

    
    function stepOffset(step, container) {
      return step.getBoundingClientRect().left
        - container.getBoundingClientRect().left
        + container.scrollLeft;
    }

    
    function indicatorPad(tab) {
      if (!tab) return 0;
      var value = parseFloat(getComputedStyle(tab, '::before').left);
      return isNaN(value) ? 0 : Math.abs(value);
    }

    function moveIndicator(index, instant) {
      var indicator = guide.querySelector('.br-ring-guide__tab-indicator');
      var tabBar = guide.querySelector('.br-ring-guide__tab-bar');
      if (!indicator || !tabBar || !tabs[index]) return;

      var tab = tabs[index];
      var pad = indicatorPad(tab);
      var width = tab.offsetWidth;

     
      if (width <= 0) return;

      if (instant) {
        indicator.style.transition = 'none';
      }

      indicator.style.left = (tab.offsetLeft - pad) + 'px';
      indicator.style.width = (width + pad * 2) + 'px';
      indicator.style.height = tab.offsetHeight + 'px';
      indicator.style.top = tab.offsetTop + 'px';

      if (instant) {
        /* Re-enable the transition once the browser has painted the position. */
        requestAnimationFrame(function () {
          indicator.style.transition = '';
          guide.classList.add('br-ring-guide--indicator-ready');
        });
      } else {
        guide.classList.add('br-ring-guide--indicator-ready');
      }
    }

    function showPanel(index) {
      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      var stepsContainer = panels[index]
        ? panels[index].querySelector('.br-ring-guide__steps')
        : null;
      if (stepsContainer) stepsContainer.scrollLeft = 0;
    }

   
    function activateTab(index, initial) {
      currentTab = index;
      currentStep = 0;

      if (inEditor && sectionId) editorTab[sectionId] = index;

      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      if (!initial) {
        moveIndicator(index, false);
      }

      showPanel(index);
      updateNav();
    }

    function getMetrics(total) {
      var isMobile = window.innerWidth < 600;
      var pageSize = isMobile ? 1 : 3;
      var totalPages = Math.max(1, Math.ceil(total / pageSize));
      return { isMobile: isMobile, pageSize: pageSize, totalPages: totalPages };
    }

    function stepNav(dir) {
      var activePanel = panels[currentTab];
      if (!activePanel) return;

      var stepsContainer = activePanel.querySelector('.br-ring-guide__steps');
      var steps = activePanel.querySelectorAll('.br-ring-guide__step');
      var total = steps.length;
      if (!stepsContainer || total <= 0) return;

      var m = getMetrics(total);

      var next = currentStep + dir;
      if (next < 0 || next > m.totalPages - 1) return;

      currentStep = next;
      var step = steps[currentStep * m.pageSize];
      if (step) {
        var left = stepOffset(step, stepsContainer);
        programmaticScroll = { left: left, expires: Date.now() + 800 };
        stepsContainer.scrollTo({
          left: left,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      updateNav();
    }

    function updateNav() {
      var activePanel = panels[currentTab];
      if (!activePanel) return;

      var steps = activePanel.querySelectorAll('.br-ring-guide__step');
      var total = steps.length;

      var pageEl = guide.querySelector('.br-ring-guide__pagination');
      var navContainer = guide.querySelector('.br-ring-guide__nav');
      var prevBtn = guide.querySelector('.br-ring-guide__nav-btn--prev');
      var nextBtn = guide.querySelector('.br-ring-guide__nav-btn--next');

      var m = getMetrics(total);

      /* Clamp position — breakpoint changes and tab switches can leave it stale */
      if (currentStep > m.totalPages - 1) currentStep = m.totalPages - 1;
      if (currentStep < 0) currentStep = 0;

      /* Desktop: everything fits when there are 3 or fewer steps → hide controls */
      var hideNav = !m.isMobile && total <= 3;

      if (pageEl) {
        if (hideNav) {
          pageEl.classList.add('br-ring-guide__pagination--hidden');
        } else {
          pageEl.classList.remove('br-ring-guide__pagination--hidden');
          pageEl.textContent = (currentStep + 1) + '/' + m.totalPages;
        }
      }

      if (navContainer) {
        if (hideNav) {
          navContainer.classList.add('br-ring-guide__nav--hidden');
        } else {
          navContainer.classList.remove('br-ring-guide__nav--hidden');
        }
      }

      if (prevBtn) prevBtn.disabled = currentStep <= 0;
      if (nextBtn) nextBtn.disabled = currentStep >= m.totalPages - 1;

      var liveRegion = guide.querySelector('.br-ring-guide__live');
      if (liveRegion && total > 0) {
        if (m.isMobile) {
          var stepLabel = steps[currentStep]
            ? steps[currentStep].querySelector('.br-ring-guide__step-label')
            : null;
          liveRegion.textContent =
            (stepLabel ? stepLabel.textContent : 'Step ' + (currentStep + 1)) +
            ' of ' + total;
        } else {
          liveRegion.textContent = 'Page ' + (currentStep + 1) + ' of ' + m.totalPages;
        }
      }
    }

    function handleTabKeydown(e) {
      var key = e.key;
      var index = currentTab;
      var total = tabs.length;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        e.preventDefault();
        index = (index + 1) % total;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        e.preventDefault();
        index = (index - 1 + total) % total;
      } else if (key === 'Home') {
        e.preventDefault();
        index = 0;
      } else if (key === 'End') {
        e.preventDefault();
        index = total - 1;
      } else {
        return;
      }

      activateTab(index);
      tabs[index].focus();
    }

    /* Bind events */
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activateTab(i); });
    });

    var tabBar = guide.querySelector('.br-ring-guide__tab-bar');
    if (tabBar) {
      tabBar.addEventListener('keydown', handleTabKeydown);
    }

    var prevBtn = guide.querySelector('.br-ring-guide__nav-btn--prev');
    var nextBtn = guide.querySelector('.br-ring-guide__nav-btn--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { stepNav(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepNav(1); });

    /* Scroll listener for mobile swipe */
    panels.forEach(function (panel) {
      var stepsContainer = panel.querySelector('.br-ring-guide__steps');
      if (!stepsContainer) return;

      var scrollTimeout;
      stepsContainer.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var steps = stepsContainer.querySelectorAll('.br-ring-guide__step');
          if (!steps.length) return;

          var containerLeft = stepsContainer.scrollLeft;
          var maxScroll = stepsContainer.scrollWidth - stepsContainer.clientWidth;

          if (programmaticScroll) {
            if (Math.abs(containerLeft - programmaticScroll.left) <= 2 ||
                (maxScroll > 0 && maxScroll - containerLeft <= 2) ||
                Date.now() > programmaticScroll.expires) {
              programmaticScroll = null;
            }
            return;
          }

          var closestIndex = 0;
          var closestDist = Infinity;

          steps.forEach(function (step, i) {
            var dist = Math.abs(stepOffset(step, stepsContainer) - containerLeft);
            if (dist < closestDist) {
              closestDist = dist;
              closestIndex = i;
            }
          });
          var m = getMetrics(steps.length);
          var page;
          if (maxScroll > 0 && maxScroll - containerLeft <= 2) {
            page = m.totalPages - 1;
          } else {
            page = Math.floor(closestIndex / m.pageSize);
          }
          if (page > m.totalPages - 1) page = m.totalPages - 1;
          if (page < 0) page = 0;

          if (panel === panels[currentTab]) {
            currentStep = page;
            updateNav();
          }
        }, 60);
      }, { passive: true });
    });

 
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        updateNav();
        moveIndicator(currentTab, true);
      }, 100);
    });

    if (typeof ResizeObserver === 'function') {
      var tabBarEl = guide.querySelector('.br-ring-guide__tab-bar');
      if (tabBarEl) {
        new ResizeObserver(function () {
          moveIndicator(currentTab, true);
        }).observe(tabBarEl);
      }
    }

    guide._reinit = function () {
      updateNav();
      
      requestAnimationFrame(function () {
        moveIndicator(currentTab, true);
      });
    };

    
    guide._reveal = function (step) {
      var panelIndex = -1;
      panels.forEach(function (panel, i) {
        if (panelIndex < 0 && panel.contains(step)) panelIndex = i;
      });
      if (panelIndex < 0) return;

      if (panelIndex !== currentTab) activateTab(panelIndex);

      var panel = panels[panelIndex];
      var stepsContainer = panel.querySelector('.br-ring-guide__steps');
      var steps = Array.from(panel.querySelectorAll('.br-ring-guide__step'));
      var index = steps.indexOf(step);
      if (!stepsContainer || index < 0) return;

      var m = getMetrics(steps.length);
      currentStep = Math.min(Math.floor(index / m.pageSize), m.totalPages - 1);

      var lead = steps[currentStep * m.pageSize];
      if (lead) {
        var left = stepOffset(lead, stepsContainer);
        programmaticScroll = { left: left, expires: Date.now() + 800 };
        stepsContainer.scrollTo({
          left: left,
          behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }

      updateNav();
    };

   
    var startTab = 0;
    if (inEditor && sectionId && editorTab[sectionId] != null) {
      startTab = Math.min(editorTab[sectionId], tabs.length - 1);
    }

   
    activateTab(startTab, true);
    requestAnimationFrame(function () {
      moveIndicator(startTab, true);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        moveIndicator(currentTab, true);
      });
    }
  }

  function initAll() {
    dedupeModals();
    var guides = document.querySelectorAll('.br-ring-guide');
    guides.forEach(function (guide) {
      if (!guide._brRingSizeGuideInitialized) {
        guide._brRingSizeGuideInitialized = true;
        initGuide(guide);
      } else if (guide._reinit) {
        guide._reinit();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.br-ring-guide')) initAll();
    });

    document.addEventListener('shopify:block:select', function (event) {
      var step = event.target.closest
        ? event.target.closest('.br-ring-guide__step')
        : null;
      if (!step) return;

      var guide = step.closest('.br-ring-guide');
      if (guide && guide._reveal) guide._reveal(step);
    });
  }

  /* Expose global API */
  window.BrRingSizeGuide = {
    init: function () {
      initAll();
    }
  };


  var cachedGuide = null;

  var OPEN_GRACE_MS = 300;

  function modal() {
    return document.getElementById('ring-size-modal');
  }
  function dedupeModals() {
    var all = document.querySelectorAll('#ring-size-modal');
    for (var i = 1; i < all.length; i++) {
      if (window.console && console.warn) {
        console.warn('[ring-size-guide] removed a duplicate #ring-size-modal — a stale copy is still rendering somewhere.');
      }
      all[i].parentNode.removeChild(all[i]);
    }
  }
  window.openRingSizeModal = function (returnFocusTo) {
    var m = modal();
    if (!m) return;

    if (m.parentElement !== document.body) document.body.appendChild(m);
    var scrollY = window.scrollY || window.pageYOffset || 0;
    m.dataset.restoreScroll = String(scrollY);
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add('modal-open');
    m.classList.add('active');

    
    m.previouslyFocusedElement = returnFocusTo || document.activeElement;
    var closeButton = m.querySelector('.br-ring-guide__close');
    if (closeButton) closeButton.focus();

    var handleClickOutside = function (event) {
      if (!event.target.closest('.modal__container')) window.closeRingSizeModal();
    };

    var handleKeyboard = function (event) {
      if (event.key === 'Escape') {
        window.closeRingSizeModal();
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.filter.call(
        m.querySelectorAll(
          'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ),
        function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    m.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleKeyboard);

    var hidden = [];
    document.querySelectorAll('body > *:not(#ring-size-modal):not(script):not(style)').forEach(function (el) {
      if (el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
      hidden.push(el);
    });

    m.cleanup = function () {
      m.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleKeyboard);
      hidden.forEach(function (el) {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      });
      hidden = [];
    };
  };

  window.closeRingSizeModal = function () {
    var m = modal();
    if (!m) return;

    m.classList.remove('active');
    document.body.classList.remove('modal-open');
    document.body.style.top = '';

    var restore = parseInt(m.dataset.restoreScroll || '0', 10);
    if (!isNaN(restore)) window.scrollTo(0, restore);

    if (m.cleanup) {
      m.cleanup();
      m.cleanup = null;
    }

    var target = m.previouslyFocusedElement;
    m.previouslyFocusedElement = null;
    if (target && document.contains(target) && typeof target.focus === 'function') {
      target.focus();
    }
  };

  function setStatus(text) {
    var el = document.querySelector('#ring-size-modal [data-guide-status]');
    if (el) el.textContent = text;
  }

  function loadGuide(url) {
    if (cachedGuide) return Promise.resolve(cachedGuide);

    return fetch(url, { credentials: 'same-origin', cache: 'no-cache' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var guide = doc.querySelector('.br-ring-guide');
        if (!guide) throw new Error('no guide on page');
        guide.classList.remove('br-ring-guide--page');

        var header = guide.querySelector('.br-ring-guide__header');
        var title = guide.querySelector('.br-ring-guide__title');
        if (title) title.id = 'ring-size-modal-title';

        if (header && !guide.querySelector('.br-ring-guide__close')) {
          var close = document.createElement('button');
          close.type = 'button';
          close.className = 'br-ring-guide__close';
          close.setAttribute('data-guide-close', '');
          close.setAttribute('aria-label', 'Close ring size guide');
          close.innerHTML =
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
            '<path d="M4 4L20 20" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
            '<path d="M20 4L4 20" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
            '</svg>';
          header.appendChild(close);
        }

        cachedGuide = guide;
        return guide;
      });
  }

  function fillModal(url) {
    var m = modal();
    if (!m) return Promise.reject(new Error('no modal'));

    var content = m.querySelector('.modal__content');
    if (content && !content.querySelector('[data-guide-placeholder]')) {
      /* Already filled from an earlier open. */
      m.setAttribute('aria-busy', 'false');
      initAll();
      return Promise.resolve();
    }

    return loadGuide(url).then(function (guide) {
      var hadFocus = m.contains(document.activeElement);

      content.innerHTML = '';
      content.appendChild(guide.cloneNode(true));
      m.setAttribute('aria-busy', 'false');
      initAll();

      if (hadFocus) {
        var close = m.querySelector('.br-ring-guide__close');
        if (close) close.focus();
      }
    });
  }

  
  function prefetchGuide() {
    if (cachedGuide) return;
    var m = modal();
    if (!m) return;
    var url = m.getAttribute('data-guide-url');
    if (!url) return;
    loadGuide(url).catch(function () { /* the click path reports it */ });
  }
 
  function prefetchImages() {
    if (!cachedGuide) return;
    var panel = cachedGuide.querySelector('.br-ring-guide__panel');
    if (!panel) return;
    panel.querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src');
      if (!src) return;
      var warm = new Image();
      if (img.getAttribute('srcset')) warm.srcset = img.getAttribute('srcset');
      if (img.getAttribute('sizes')) warm.sizes = img.getAttribute('sizes');
      warm.src = src;
    });
  }

  function schedulePrefetch() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchGuide, { timeout: 1200 });
    } else {
      setTimeout(prefetchGuide, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePrefetch);
  } else {
    schedulePrefetch();
  }

  /* Hovering, focusing or touching the link is a strong hint it is about to be
     used — fetch immediately at that point rather than waiting for idle. */
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (!event.target.closest) return;
      if (!event.target.closest('.ring-size-guide-trigger')) return;
      prefetchGuide();
      /* cachedGuide may land a moment later; warm images once it has. */
      setTimeout(prefetchImages, 0);
    }, { passive: true, capture: true });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ring-size-guide-trigger');
    if (!trigger) return;

    var m = modal();
    if (!m) return;                       /* no dialog here — let the link work */

    var url = m.getAttribute('data-guide-url');
    if (!url) return;

    /* Let modified clicks (new tab, download, middle click) behave normally. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        (typeof event.button === 'number' && event.button !== 0)) {
      return;
    }

    event.preventDefault();

    var revealed = false;
    var graceTimer = null;

    function reveal() {
      if (revealed) return;
      revealed = true;
      if (graceTimer) {
        clearTimeout(graceTimer);
        graceTimer = null;
      }
      if (typeof window.openRingSizeModal === 'function') {
        window.openRingSizeModal(trigger);
      }
      /* Now that it is on screen, re-measure the pill. */
      initAll();
    }

    /* Slow network only: past the grace window, open the skeleton so the click
       is not left with no feedback at all. */
    if (!cachedGuide) {
      graceTimer = setTimeout(function () {
        setStatus('Loading the ring size guide…');
        reveal();
      }, OPEN_GRACE_MS);
    }

    fillModal(url).then(reveal).catch(function (error) {
      /* Nothing useful to show — send them to the real page instead of
         leaving an empty dialog on screen. */
      if (graceTimer) {
        clearTimeout(graceTimer);
        graceTimer = null;
      }
      if (window.console && console.warn) {
        console.warn('[ring-size-guide] falling back to navigation:', error.message);
      }
      if (revealed && typeof window.closeRingSizeModal === 'function') {
        window.closeRingSizeModal();
      }
      window.location.href = trigger.getAttribute('href') || url;
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-guide-close]')) return;
    event.preventDefault();
    if (typeof window.closeRingSizeModal === 'function') {
      window.closeRingSizeModal();
    }
  });

  var zoomLayer = null;
  var zoomReturnFocus = null;

  function buildZoomLayer() {
    if (zoomLayer) return zoomLayer;

    zoomLayer = document.createElement('div');
    zoomLayer.className = 'br-ring-zoom';
    zoomLayer.setAttribute('role', 'dialog');
    zoomLayer.setAttribute('aria-modal', 'true');
    zoomLayer.setAttribute('aria-label', 'Enlarged step photo');
    zoomLayer.innerHTML =
      '<button type="button" class="br-ring-zoom__toggle" aria-pressed="false">Zoom in</button>' +
      '<button type="button" class="br-ring-zoom__close" aria-label="Close the enlarged photo">' +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M4 4L20 20" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
      '<path d="M20 4L4 20" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>' +
      '</svg></button>' +
      '<img class="br-ring-zoom__image" alt="">';

    zoomLayer.addEventListener('click', function (event) {
      if (event.target.closest('.br-ring-zoom__close')) {
        closeZoom();
        return;
      }
      if (event.target.closest('.br-ring-zoom__toggle')) {
        toggleMagnify();
        return;
      }
      /* Clicking the photo magnifies it; clicking the backdrop dismisses. */
      if (event.target.closest('.br-ring-zoom__image')) {
        toggleMagnify();
        return;
      }
      closeZoom();
    });

    document.body.appendChild(zoomLayer);
    return zoomLayer;
  }

  function toggleMagnify(force) {
    if (!zoomLayer) return;
    var on = typeof force === 'boolean'
      ? force
      : !zoomLayer.classList.contains('is-magnified');

    zoomLayer.classList.toggle('is-magnified', on);

    var toggle = zoomLayer.querySelector('.br-ring-zoom__toggle');
    if (toggle) {
      toggle.setAttribute('aria-pressed', String(on));
      toggle.textContent = on ? 'Zoom out' : 'Zoom in';
    }

    /* Start the magnified view centred rather than at the top-left corner. */
    if (on) {
      zoomLayer.scrollLeft = (zoomLayer.scrollWidth - zoomLayer.clientWidth) / 2;
      zoomLayer.scrollTop = (zoomLayer.scrollHeight - zoomLayer.clientHeight) / 2;
    } else {
      zoomLayer.scrollLeft = 0;
      zoomLayer.scrollTop = 0;
    }
  }

  function handleZoomKeys(event) {
    if (!zoomLayer || !zoomLayer.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      /* Capture phase + stopPropagation: the guide's own Escape handler is
         listening on document too, and would otherwise close both at once. */
      event.stopPropagation();
      event.preventDefault();
      closeZoom();
      return;
    }

    if (event.key === 'Tab') {
      /* Cycle the two controls rather than letting focus escape to the guide
         underneath, which is inert to the eye but not to the tab key. */
      event.preventDefault();
      var focusable = Array.prototype.slice.call(
        zoomLayer.querySelectorAll('.br-ring-zoom__toggle, .br-ring-zoom__close')
      );
      if (!focusable.length) return;
      var i = focusable.indexOf(document.activeElement);
      var nextIndex = event.shiftKey ? i - 1 : i + 1;
      if (nextIndex < 0) nextIndex = focusable.length - 1;
      if (nextIndex >= focusable.length) nextIndex = 0;
      focusable[nextIndex].focus();
    }
  }

  function openZoom(trigger) {
    var layer = buildZoomLayer();
    var img = layer.querySelector('.br-ring-zoom__image');
    var src = trigger.getAttribute('data-zoom-src');
    if (!src) return;

    img.src = src;
    /* The alt the merchant wrote, if any; the surrounding step text already
       carries the instruction, so an empty alt is the honest default. */
    img.alt = trigger.getAttribute('data-zoom-alt') || '';

    zoomReturnFocus = trigger;
    toggleMagnify(false);          /* always open fitted to the screen */
    layer.classList.add('is-open');

    document.addEventListener('keydown', handleZoomKeys, true);

    var close = layer.querySelector('.br-ring-zoom__close');
    if (close) close.focus();
  }

  function closeZoom() {
    if (!zoomLayer) return;
    zoomLayer.classList.remove('is-open');
    toggleMagnify(false);
    document.removeEventListener('keydown', handleZoomKeys, true);

    var target = zoomReturnFocus;
    zoomReturnFocus = null;
    if (target && document.contains(target) && typeof target.focus === 'function') {
      target.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.br-ring-guide__zoom');
    if (!trigger) return;
    event.preventDefault();
    openZoom(trigger);
  });
})();
